export default {
  'menuDecorate.title': '平板点餐Pro版',
  'menuDecorate.dishSelector.title': '菜品选择器',
  'menuDecorate.description': '开启后，平板点餐进入Pro模式，将呈现下面选择的装修模版；未开启时可设置装修模版。',
  'menuDecorate.enableMode': '启用此模式',
  'menuDecoration.mode.landscape': '横屏点餐模式 (16:10)',
  'menuDecoration.mode.landscape_ipad_pro': '横屏点餐模式 (4:3)',
  'menuDecoration.mode.portrait': '竖屏点餐模式 (10:16)',
  'menuDecoration.mode.default': '无装修',
  'menuDecoration.mode.landscape.desc': '适配 iMin T01 或 Amazon Fire HD 10 平板设备。',
  'menuDecoration.mode.landscape_ipad_pro.desc': '适配 iPad Pro 平板设备。',
  'menuDecoration.mode.portrait.desc': '适配 iMin T01 或 Amazon Fire HD 10 平板设备。',
  'menuDecoration.wrongEntrace': '请从“智能点餐 > 平板点餐 > 平板点餐Pro版”入口进入此页面',
  'menuDecorate.colorAndTheme': '颜色 & 主题',
  'menuDecorate.action.startEdit': '进入装修',
  'menuDecorate.action.preview': '效果预览',
  'menuDecorate.action.exitEdit': '退出编辑',
  'menuDecorate.action.saveAndExitEdit': '保存 & 退出编辑',
  'menuDecorate.action.addPage': '增加页面',
  'menuDecorate.action.changeImage': '更换图片',
  'menuDecorate.action.addDishLink': '增加菜品链接',
  'menuDecorate.action.duplicatedComponent': '复制组件',
  'menuDecorate.action.applyMode': '应用此模式',
  'menuDecorate.action.appliedMode': '已应用',
  'menuDecorate.colorAndTheme.title': '颜色主题',
  'menuDecorate.noItems': '请添加菜品链接',
  'menuDecorate.chooseCategory': '选择分类',
  'menuDecorate.component.column.enableBackgroundFill': '背景填充',
  'menuDecorate.component.column.backgroundColor': '背景颜色',
  'menuDecorate.component.column.enableBackgroundStroke': '背景边框',
  'menuDecorate.component.column.backgroundStrokeColor': '边框色',
  'menuDecorate.component.section.componentLayout': '组件布局',
  'menuDecorate.component.column.showDishNname': '菜品名',
  'menuDecorate.component.column.fontFamily': '字体',
  'menuDecorate.component.column.cnFontFamily': '中文字体',
  'menuDecorate.component.column.enFontFamily': '英文字体',
  'menuDecorate.component.column.fontColor': '字体颜色',
  'menuDecorate.component.column.fontSize': '字号',
  'menuDecorate.component.column.cnFontSize': '中文字号',
  'menuDecorate.component.column.enFontSize': '英文字号',
  'menuDecorate.component.column.showDishInfo': '菜品信息',
  'menuDecorate.component.column.showButton': '按钮',
  'menuDecorate.component.column.buttonStyle': '按钮样式',
  'menuDecorate.component.column.buttonStyle.regular': '常规',
  'menuDecorate.component.column.buttonStyle.transparent': '透明',
  'menuDecorate.component.column.buttonBackgroundColor': '按钮背景颜色',
  'menuDecorate.component.column.buttonContentColor': '按钮内容颜色',
  'menuDecorate.component.column.buttonSize': '按钮大小',
  'menuDecorate.component.section.dishLinkSetting': '菜品链接设置',
  'menuDecorate.component.action.showMoreLayouts': '显示更多布局',
  'menuDecorate.component.action.hideMoreLayouts': '隐藏更多布局',
  'menuDecorate.uploadImage': '上传图片',
  'menuDecorate.imageRequest': '图片要求:',
  'menuDecorate.imageUploadGuide':
    '支持.jpg .jpeg .png格式的图片，图片尺寸限制在4MB以内。图片大小必须为 {width} x {height}',
  'menuDecorate.imageUploadGuide.sizeNotMatched': '图片大小必须为 {width} x {height}',
  'menuDecorate.imageUploadGuide.formatNotMatched': '图片格式必须为 .jpg, .jpeg, .png',
  'menuDecorate.imageUploadGuide.sizeTooLarge': '图片尺寸限制在4MB以内',
  'menuDecorate.deletePromptTitle': '确认要删除已经装修的页面？',
  'menuDecorate.deletePromptContent': '删除页面的同时，装修内容也将一并删除。',
  'menuDecorate.savePromptTitle': '保存已编辑的内容？',
  'menuDecorate.savePromptContent': '当前页面有未保存的装修内容，请先保存。',
  'menuDecorate.changeBackgroundPromptTitle': '是否保留菜品链接？',
  'menuDecorate.changeBackgroundPromptContent': '已经创建的菜品链接，是否在更换图片后继续保留。',
  'menuDecoration.componentIntersectionPromptTitle': '组件重叠请修改',
  'menuDecoration.componentIntersectionPromptContent': '有组件重叠在一起，为避免用户误点，请修改后再保存。',
  'menuDecoration.componentsWithoutDishesPromptTitle': '组件未设置菜品',
  'menuDecoration.componentsWithoutDishesPromptContent': '有组件尚未设置菜品，请修改后再保存。',
  'menuDecoration.noPictureUploadedPromptTitle': '未上传图片',
  'menuDecoration.noPictureUploadedPromptContent': '当前页面尚未上传图片，请上传图片后再保存。',
  'menuDecorate.saveSuccess': '保存平板点餐Pro版设置成功',
  'menuDecorate.saveOnErrors.no_background_image.title': '未上传图片',
  'menuDecorate.saveOnErrors.no_background_image.description': '有页面尚未上传图片，请上传图片后再保存。',
  'menuDecorate.saveOnErrors.hotspot_without_meal.title': '组件未设置菜品',
  'menuDecorate.saveOnErrors.hotspot_without_meal.description': '有组件尚未设置菜品，请修改后再保存。',
  'menuDecorate.saveOnErrors.hotspots_overlaps.title': '组件重叠请修改',
  'menuDecorate.saveOnErrors.hotspots_overlaps.description': '有组件重叠在一起，为避免用户误点，请修改后再保存。',
  'menuDecorate.addedToCurrentPage': '已添加到当前页面',
  'menuDecorate.currentSelection': '当前链接菜品',
  'menuDecorate.backToModify': '返回修改',
  'menuDecorate.saveImmediately': '立即保存',
  'menuDecorate.reserveHotspots.title': '是否保留菜品链接？',
  'menuDecorate.reserveHotspots.description': '已经创建的菜品链接，是否在更换图片后继续保留。',
  'menuDecorate.unDecoratedMenus.title': '部分菜单尚未设置菜品',
  'menuDecorate.unDecoratedMenus.description': '菜单 {menuNames} 尚未设置任何菜品，是否立即保存？',
  'menuDecorate.cannotPublishMenuDecoration': '由于你没有发布菜单装修的权限，所以您无法切换装修模式',
  'menuDecorate.isMember': '会员价',
  'menuDecorate.points': '积分',
  'menuDecorate.compSize': '组件尺寸',
  'menuDecorate.compWidth': '宽',
  'menuDecorate.compHeight': '高',
};
